<template>
        <v-container fluid class="pt-0">
            <v-layout justify-center row fill-height>
                <router-view/>
            </v-layout>
        </v-container>
</template>

<script>
    export default {
        name: "AppContent"
    }
</script>

<style scoped>

</style>
